
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import SearchIcon from 'mdi-vue/Magnify';

import LayoutContent from '@/components/LayoutContent.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';

import api from '@/libs/api';
import hasPermission from '@/libs/permission';
import { UsersApiResponse, User } from '@/libs/api.interfaces';
import UserListFilter from './components/Filter/UserList.vue';

@Component({
  components: {
    Button,
    LayoutContent,
    AddIcon,
    SearchIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    UserListFilter,
  },
  methods: {
    hasPermission,
  },
})
export default class UserList extends Vue {
  searchOpen = false;

  loading = true;
  users: User[] = [];
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  hasPermission!: (val: string | string[]) => boolean;

  mounted() {
    this.getUsers();
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  get type() {
    return this.$route.params.type;
  }

  @Watch('page')
  onPageChange() {
    this.getUsers();
  }

  @Watch('$route')
  onRouteChange() {
    this.getUsers();
  }

  async getUsers() {
    try {
      this.loading = true;

      let name;
      if (typeof this.$route.query.name === 'string') {
        name = this.$route.query.name.split(',');
      }

      let group;
      if (typeof this.$route.query.group === 'string') {
        group = this.$route.query.group.split(',');
      }

      let status;
      if (typeof this.$route.query.status === 'string') {
        status = this.$route.query.status.split(',');
      }

      let role;
      if (typeof this.$route.query.role === 'string') {
        role = this.$route.query.role.split(',');
      }

      let email;
      if (typeof this.$route.query.email === 'string') {
        email = this.$route.query.email.split(',');
      }

      let merchantCode;
      if (typeof this.$route.query.merchant_code === 'string') {
        merchantCode = this.$route.query.merchant_code;
      }

      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get<UsersApiResponse>('/users', {
        params: {
          page: this.page,
          name,
          group_id: group,
          status,
          role_id: role,
          email,
          is_internal: this.type === 'internal',
          merchant_code: merchantCode,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */
      this.users = data.data;
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }
}
